import { Input, InputRef } from 'antd';
import React, { useImperativeHandle, useRef } from 'react';
import PhoneInput from 'react-phone-number-input';
import 'styles/phone-input.css';

const CustomInput = React.forwardRef<HTMLInputElement>((props, ref) => {
  const inputRef = useRef<InputRef>(null);

  useImperativeHandle(ref, () => inputRef.current?.input as HTMLInputElement, [
    inputRef,
  ]);

  return <Input size="large" {...props} ref={inputRef} />;
});

CustomInput.displayName = 'CustomInput';

interface PhoneNumberInputProps {
  phoneNumberField?: string;
  placeholder?: string;
  value?: string;
  onChange?: (value?: string) => void;
}

const PhoneNumberInput: React.FC<PhoneNumberInputProps> = ({
  placeholder,
  value,
  onChange = () => {},
}) => {
  return (
    <PhoneInput
      onChange={onChange}
      value={value}
      placeholder={placeholder}
      inputComponent={CustomInput}
    />
  );
};

export default PhoneNumberInput;
